import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../theme';

const { colors, spacing, radius } = redesignTheme;

/**
 * Canonical Redesign modal card. Spread into the caller's paper class and
 * add the modal-specific properties (maxWidth, scroll behavior...) after
 * the spread.
 */
export const modalPaperStyle = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.md,
  padding: spacing.md,
  borderRadius: radius.md,
  backgroundColor: colors.white,
  boxShadow: '0 16px 48px rgba(0, 0, 0, 0.12)',
  boxSizing: 'border-box',
} as const;

export const useRedesignModalStyles = makeStyles(() => ({
  overlay: {
    position: 'fixed',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing.sm,
    boxSizing: 'border-box',
  },
}));
